@if (accountService.subscriptionExpired) {
  <div id="subscription-status-banner">
    <span class="important">Important:</span>
    Your {{ uiService.productName }} subscription has expired. You can still review and modify your account, but
    recovery points are not currently being captured and you are not able to execute tests or recoveries. You can renew
    your subscription
    <a [routerLink]="uiService.buildSubscriptionSettingsUrl(accountService.accountId)">here.</a>
  </div>
}

<!-- This shows a banner if there is an AWS outage -->
@if (awsOutageObj$ | async; as awsOutageObj) {
  @if (awsOutageObj?.visible == true) {
    <div id="subscription-status-banner">
      <span class="important"> </span>
      <span [innerHtml]="awsOutageObj?.safeHtml"></span>
    </div>
  }
}

<account-navigation [account-id]="accountId" [initialized]="initialized"></account-navigation>
